export default {
  '--dialog-background': '#1e1e1e',
  '--dialog-message-color': '#bbb'
};